import { render, staticRenderFns } from "./UserResetPasswordDrawer.vue?vue&type=template&id=b0f37f18"
import script from "./UserResetPasswordDrawer.vue?vue&type=script&lang=js"
export * from "./UserResetPasswordDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports